import { render } from "./AddNewEmployee.vue?vue&type=template&id=541f34bb"
import script from "./AddNewEmployee.vue?vue&type=script&lang=js"
export * from "./AddNewEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__